import React, { Component } from 'react';
import { Collapse, Card, Avatar } from 'antd';
import { inject, observer } from 'mobx-react';
import { TestSignalView } from './TestSignalView';
import { TethosSignalView } from './TethosSignalView';

const { Panel } = Collapse;

@inject('store')
@observer
export class SignalsView extends Component {
    componentDidMount() {
        this.props.store.strategyStore.getOdysseyStrategies();
    }

    render() {
        return (
            <div>
                <Card bordered={false} size="small">
                    <Collapse bordered={false} expandIconPosition={'right'}>
                        <Panel
                            header={
                                <div>
                                    <Avatar src="/signals/test.png" />
                                    &nbsp;&nbsp;Test Signals
                                </div>
                            }
                            key="1"
                        >
                            <TestSignalView />
                        </Panel>
                        <Panel
                            header={
                                <div>
                                    <Avatar src="/signals/TV.png" />
                                    &nbsp;&nbsp;Trading View
                                </div>
                            }
                            key="1"
                        >
                            Nope
                        </Panel>
                        <Panel
                            header={
                                <div>
                                    <Avatar src="/signals/cbs.png" />
                                    &nbsp;&nbsp;Crypto Base Scanner
                                </div>
                            }
                            key="2"
                        >
                            try again buddy
                        </Panel>
                        <Panel
                            header={
                                <div>
                                    <Avatar src="/signals/tt.png" />
                                    &nbsp;&nbsp;Tethos Crypto
                                </div>
                            }
                            key="3"
                        >
                            <TethosSignalView />
                        </Panel>
                    </Collapse>
                </Card>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/OdysseyBot/SignalsView/index.js